import CallModal from 'app/components/call/CallModal';
import CallSettings from './CallSettings';
import { T } from 'app/components/localization';
import { ButtonA } from 'app/components/presentation/buttons/ButtonClassNameA';
import { GetCallSettingsModalControl, IsCallSettingsModalOpen } from 'app/containers/call/CallSettingsModalContext';
import { GetDevices } from 'app/containers/rtc/DeviceManagerContext';
import React, { PureComponent } from 'react';

interface ICallSettingsModalProps {
  readonly close: () => void;
  readonly isOpen: boolean;
}

class CallSettingsModal extends PureComponent<ICallSettingsModalProps> {
  public render() {
    const { isOpen, close } = this.props;

    return isOpen && (
      <T>{t =>
        <CallModal
          buttons={
            <ButtonA onClick={close}>
              {t('modal.close')}
            </ButtonA>
          }
          onClose={close}
          title={t('rtc.settings.title')}
        >
          <CallSettings />
        </CallModal>
      }</T>
    );
  }
}

const CallSettingsModalInjectDependencies = () =>
  <GetDevices>{(devices) => devices &&
    <GetCallSettingsModalControl>{(control) => control &&
      <IsCallSettingsModalOpen>{(isOpen) =>
        <CallSettingsModal close={control.close} isOpen={isOpen && !devices.userAction} />
      }</IsCallSettingsModalOpen>
    }</GetCallSettingsModalControl>
  }</GetDevices>;

export default CallSettingsModalInjectDependencies;
